export const GET_CHANGELOG_DATA = 'GET_CHANGELOG_DATA';
export const PUSH_CHANGELOG_DATA = 'PUSH_CHANGELOG_DATA';
